var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSizeLarge = function SvgSizeLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    fillOpacity: 0.5,
    d: "M11 15h78v30H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    d: "M16 20h68v20H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    fillOpacity: 0.5,
    d: "M11 54h78v30H11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    d: "M16 59h68v20H16z"
  })));
};
export { SvgSizeLarge as ReactComponent };
export default __webpack_public_path__ + "img/size-large.1d4f13596a68a11ce3864217372a37d0.svg";